/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { NewsCategoryDto } from '../models';
// @ts-ignore
import type { NewsDetailDto } from '../models';
// @ts-ignore
import type { NewsListItemDto } from '../models';
// @ts-ignore
import type { NewsListResponseDto } from '../models';
/**
 * NewsApi - axios parameter creator
 * @export
 */
export const NewsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the N most recent PUBLISHED news ordered by publishedAt desc. Requires news.read.
         * @summary Latest published news for landing page widget
         * @param {number} [limit] 
         * @param {NewsCategoryDto} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestNews: async (limit?: number, category?: NewsCategoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/news/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated list of PUBLISHED news. Requires news.read.
         * @summary List published news (News Hub)
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {NewsCategoryDto} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedNews: async (page?: number, pageSize?: number, category?: NewsCategoryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns only PUBLISHED news. Requires news.read.
         * @summary Get a published news article
         * @param {number} newsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedNewsById: async (newsId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newsId' is not null or undefined
            assertParamExists('getPublishedNewsById', 'newsId', newsId)
            const localVarPath = `/api/v1/news/{newsId}`
                .replace(`{${"newsId"}}`, encodeURIComponent(String(newsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsApi - functional programming interface
 * @export
 */
export const NewsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NewsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the N most recent PUBLISHED news ordered by publishedAt desc. Requires news.read.
         * @summary Latest published news for landing page widget
         * @param {number} [limit] 
         * @param {NewsCategoryDto} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestNews(limit?: number, category?: NewsCategoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewsListItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestNews(limit, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsApi.getLatestNews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated list of PUBLISHED news. Requires news.read.
         * @summary List published news (News Hub)
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {NewsCategoryDto} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedNews(page?: number, pageSize?: number, category?: NewsCategoryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedNews(page, pageSize, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsApi.getPublishedNews']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns only PUBLISHED news. Requires news.read.
         * @summary Get a published news article
         * @param {number} newsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublishedNewsById(newsId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewsDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublishedNewsById(newsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NewsApi.getPublishedNewsById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NewsApi - factory interface
 * @export
 */
export const NewsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NewsApiFp(configuration)
    return {
        /**
         * Returns the N most recent PUBLISHED news ordered by publishedAt desc. Requires news.read.
         * @summary Latest published news for landing page widget
         * @param {number} [limit] 
         * @param {NewsCategoryDto} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestNews(limit?: number, category?: NewsCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsListItemDto>> {
            return localVarFp.getLatestNews(limit, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated list of PUBLISHED news. Requires news.read.
         * @summary List published news (News Hub)
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {NewsCategoryDto} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedNews(page?: number, pageSize?: number, category?: NewsCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsListResponseDto> {
            return localVarFp.getPublishedNews(page, pageSize, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns only PUBLISHED news. Requires news.read.
         * @summary Get a published news article
         * @param {number} newsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublishedNewsById(newsId: number, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto> {
            return localVarFp.getPublishedNewsById(newsId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NewsApi - interface
 * @export
 * @interface NewsApi
 */
export interface NewsApiInterface {
    /**
     * Returns the N most recent PUBLISHED news ordered by publishedAt desc. Requires news.read.
     * @summary Latest published news for landing page widget
     * @param {number} [limit] 
     * @param {NewsCategoryDto} [category] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApiInterface
     */
    getLatestNews(limit?: number, category?: NewsCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<NewsListItemDto>>;

    /**
     * Paginated list of PUBLISHED news. Requires news.read.
     * @summary List published news (News Hub)
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {NewsCategoryDto} [category] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApiInterface
     */
    getPublishedNews(page?: number, pageSize?: number, category?: NewsCategoryDto, options?: RawAxiosRequestConfig): AxiosPromise<NewsListResponseDto>;

    /**
     * Returns only PUBLISHED news. Requires news.read.
     * @summary Get a published news article
     * @param {number} newsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApiInterface
     */
    getPublishedNewsById(newsId: number, options?: RawAxiosRequestConfig): AxiosPromise<NewsDetailDto>;

}

/**
 * NewsApi - object-oriented interface
 * @export
 * @class NewsApi
 * @extends {BaseAPI}
 */
export class NewsApi extends BaseAPI implements NewsApiInterface {
    /**
     * Returns the N most recent PUBLISHED news ordered by publishedAt desc. Requires news.read.
     * @summary Latest published news for landing page widget
     * @param {number} [limit] 
     * @param {NewsCategoryDto} [category] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getLatestNews(limit?: number, category?: NewsCategoryDto, options?: RawAxiosRequestConfig) {
        return NewsApiFp(this.configuration).getLatestNews(limit, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated list of PUBLISHED news. Requires news.read.
     * @summary List published news (News Hub)
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {NewsCategoryDto} [category] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getPublishedNews(page?: number, pageSize?: number, category?: NewsCategoryDto, options?: RawAxiosRequestConfig) {
        return NewsApiFp(this.configuration).getPublishedNews(page, pageSize, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns only PUBLISHED news. Requires news.read.
     * @summary Get a published news article
     * @param {number} newsId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsApi
     */
    public getPublishedNewsById(newsId: number, options?: RawAxiosRequestConfig) {
        return NewsApiFp(this.configuration).getPublishedNewsById(newsId, options).then((request) => request(this.axios, this.basePath));
    }
}

